<template>
  <section class="s-video">
    <div class="s-video__conts">
      <div class="s-video__col">
        <VideoBlock
          v-if="video"
          :video-id="video.videoId"
          :image="video.image" />
      </div>
    </div>
  </section>
</template>

<script>
// import SlickCarousel from '../components/common/SlickCarousel.vue'
import VideoBlock from '../components/VideoBlock.vue'
import * as lib from './../../lib/lib'

export default {
  components: {
    // SlickCarousel,
    VideoBlock,
  },
  data() {
    return {
      video: null,
      // slickKey: 0,
      // slickOptions: {
      //   draggable: false,
      //   infinite: true,
      //   autoplay: false,
      //   arrows: false,
      //   dots: true,
      //   slidesToShow: 1,
      //   slidesToScroll: 1,
      //   centerMode: false,
      // },
    }
  },

  mounted() {
    const { video } = lib.getData('videosData')

    this.video = video
  },

  methods: {
    onAfterChange() {
      document.dispatchEvent(new Event('pause-all-videos'))
    },
  },
}
</script>
